import { createFileRoute, redirect } from "@tanstack/react-router";
import { accessionRouteSchema } from "src/features/records/accession/components/route";

export const Route = createFileRoute(
  "/_layout/sites/$siteSlug/accessions/$accessionNumber",
)({
  validateSearch: (search) => accessionRouteSchema.parse(search),
  loader: (opts) => {
    throw redirect({
      ...opts,
      to: "/site/$siteSlug/accession/$accessionNumber",
    });
  },
});
